<template>
  <van-list
    class="record"
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="requestGetSourceLogs"
    offset="30"
  >
    <div class="item" v-for="(item, index) in records" :key="index">
      <div class="left">
        <div class="tit">{{ item.action_text }}</div>
        <div class="date">ID：{{ item.id }} {{ item.created_at }}</div>
      </div>
      <div class="right">
        <div class="number">
          {{ item.is_add == 0 ? "-" : "+" }}{{ item.score }}
        </div>
        <div class="balance">积分余额：{{ item.user_score_after }}</div>
      </div>
    </div>
  </van-list>
</template>
<script>
import { getSourceLogs } from "network/mall";
import { Toast } from "vant";

export default {
  name: "MallRecord",
  data() {
    return {
      userInfo: {},
      page: 0,
      records: [],
      loading: false,
      finished: false,
    };
  },
  computed: {},
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.requestGetSourceLogs();
  },
  methods: {
    requestGetSourceLogs() {
      this.loading = true;
      this.page++;
      getSourceLogs({ page: this.page })
        .then((res) => {
          if (res.data.data.length) {
            this.records = this.records.concat(res.data.data);
          }
          if (res.data.data.length < 50) {
            this.finished = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.record .item {
  padding: 15px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
.record .item .left .tit {
  font-size: 12px;
  font-weight: 600;
}
.record .item .left .date {
  margin-top: 5px;
  font-size: 12px;
  color: #707070;
}
.record .item .right .number {
  text-align: right;
  font-size: 16px;
  font-weight: 600;
}
.record .item .right .balance {
  margin-top: 5px;
  font-size: 12px;
  text-align: right;
  color: #707070;
}
</style>